<template>
  <div class="animated fadeIn">
    <loading v-if="vLoading" />
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>

    <v-col lg="12" class="ml-auto"></v-col>

    <b-card header-bg-variant="primary" header-text-variant="white">
      <template v-slot:header>
        <h6>واحدهای پولی</h6>
      </template>

      <v-btn
        class="darkGreen-mainBtn white--text border mb-4 float-start"
        style="width: 135px; height: 35px;"
        @click="$refs.activeTable100.$el.click()"
        depressed
        :disabled="!currencyOptions.length"
      >
        <v-icon class="me-1"> mdi-file-excel-outline </v-icon>
        خروجی اکسل
      </v-btn>
      <vue-excel-xlsx
        ref="activeTable100"
        :data="currencyOptions"
        :columns="ExcelFields"
        :sheet-name="`واحد‌های پولی`"
        :file-name="`واحد‌های پولی`"
      >
      </vue-excel-xlsx>

      <v-btn
        :disabled="gettingReceipt || !currencyOptions.length"
        class="darkRed-mainBtn white--text mb-4 float-end"
        style="width: 135px; height: 35px; float: left"
        @click="printReceipt()"
        depressed
        ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
      >

      <b-table
        responsive
        show-empty
        :items="currencyOptions"
        :fields="fields"
        empty-text="رکوردی برای نمایش وجود ندارد"
        striped
        :busy="isBusy"
      >
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(price)="data">
          <div style="text-align: center; vertical-align: middle">
            <span v-if="!data.item.edit"
              >{{ data.value.toLocaleString() }}
              <i
                @click="startEdit(data.index)"
                class="mx-3 fa fa-edit"
                aria-hidden="true"
              ></i>
            </span>
            <span v-else>
              <b-form-input
                v-model="data.item.newPrice"
                type="number"
                placeholder="ضریب تبدیل به ریال"
              ></b-form-input
              ><br />
              ضریب قبلی: {{ data.item.price.toLocaleString() }}
              <b-btn class="mx-3" variant="success" @click="doEdit(data.index)">
                <i class="fa fa-check success" aria-hidden="true"></i> ثبت
                تغییرات
              </b-btn>
            </span>
          </div>
        </template>
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <strong>در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
      <br />
    </b-card>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">واحد‌های پولی</h3>
      <b-table :items="currencyOptions" :fields="printFields">
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <template v-slot:cell(price)="data">
          <div style="text-align: center; vertical-align: middle">
            <span v-if="!data.item.edit"
              >{{ data.value.toLocaleString() }}
            </span>
            <span v-else>
              <b-form-input
                v-model="data.item.newPrice"
                type="number"
                placeholder="ضریب تبدیل به ریال"
              ></b-form-input
              ><br />
              ضریب قبلی: {{ data.item.price.toLocaleString() }}
            </span>
          </div>
        </template>
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import Var from "../../../variables";
import router from "../../router";


export default {
  components: {
   
  },
  data: function () {
    return {
      printInvoice: {},
      gettingReceipt: false,
      guide: false,
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      fields: [
        { key: "index", label: "#" },
        { key: "text", label: "واحد پول" },
        { key: "precision", label: "ارقام اعشار مجاز" },
        { key: "price", label: "ضریب تبدیل به ریال" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "text", label: "واحد پول" },
        { key: "precision", label: "ارقام اعشار مجاز" },
        { key: "price", label: "ضریب تبدیل به ریال" },
      ],
      ExcelFields: [
        { field: "text", label: "واحد پول" },
        { field: "precision", label: "ارقام اعشار مجاز" },
        { field: "price", label: "ضریب تبدیل به ریال" },
      ],
      isBusy: false,
    };
  },

  methods: {
    print(item) {
      this.gettingReceipt = true;
      Axios.post(
        this.baseUrl + "/ppkpms/orders/getInfo",
        {
          shopInvoiceId: item.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.gettingReceipt = false;
          if (res.status == 200) {
            this.printInvoice = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .then(() => {
          setTimeout(() => {
            this.printReceipt();
          }, 400);
        })
        .catch((err) => {
          console.log(err);
          this.gettingReceipt = false;
          this.toast(err.response.data, "error");
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title></title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
    toggleHelp() {
      this.guide = !this.guide;
    },
    getValues() {
      this.vLoading = true;
      this.isBusy = true;
      let totalCount = this.currencyOptions.length;
      let counter = 0;
      this.currencyOptions.forEach((currency, index) =>
        Axios.post(
          this.baseUrl + "/ppkpms/office/options/getInfo",
          {
            key: currency.value,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("token"),
            },
          }
        )
          .then((res) => {
            if (res.status == 200) {
              this.currencyOptions[index].price = res.data;
              counter++;
              if (counter == totalCount) {
                this.vLoading = false;
                this.isBusy = false;
              }
            }
          })
          .catch((err) => {
            this.toast(err.response.data, "error");
            this.vLoading = false;
          })
      );
    },
    startEdit(itemIndex) {
      this.isBusy = true;
      this.currencyOptions[itemIndex].newPrice =
        this.currencyOptions[itemIndex].price;
      this.currencyOptions[itemIndex].edit = true;
      this.isBusy = false;
    },
    doEdit(itemIndex) {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/office/options/edit",
        {
          key: this.currencyOptions[itemIndex].value,
          value: this.currencyOptions[itemIndex].newPrice,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.currencyOptions[itemIndex].edit = false;
            this.getValues();
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },
  },

  mounted() {
    this.getValues();
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
